/* 肥後屋LPデザイン — 追従CTAの退避（トップページのみ）
 *
 * HIGOYA-99: 「特定のセクションから下で追従ボタンが見えなくなる」報告への対策。
 *
 * position: fixed は画面ではなく「先祖に transform / filter / perspective /
 * will-change / contain が付いていたら、その先祖」を基準にしてしまう。そうなると
 * ボタンはセクションの中に閉じ込められ、そのセクションを過ぎたところで
 * 画面外へ流れていく（＝途中から見えなくなる）。
 *
 * 現在のコードには該当する指定は無いが、セクションの入れ物には
 * テーマエディタの並べ替え演出やアプリの埋め込みなど、あとから
 * transform が付き得る。ボタン自体を <body> 直下へ移しておけば、
 * どのセクションに置いても影響を受けなくなる。
 *
 * カスタム要素にしているのは、テーマエディタがセクションを再描画するたびに
 * 自動で退避をやり直すため（移動そのものが disconnect → connect を起こすので、
 * 既に body 直下なら何もしないでガードする）。
 */
class LpFloatCta extends HTMLElement {
  connectedCallback() {
    if (this.parentElement === document.body) return;

    // セクション再描画で新しい要素が挿し込まれたとき、退避済みの古い要素が
    // body 側に残って二重表示になるのを防ぐ。
    document.querySelectorAll('body > lp-float-cta').forEach((el) => {
      if (el !== this) el.remove();
    });

    document.body.appendChild(this);
  }
}

customElements.define('lp-float-cta', LpFloatCta);
